import { getStore } from "Pub/js/storageUtils";
import { getType } from "Pub/js/utils";

/**
 * 全局信息处理
 * @param {Function} callback 全局信息变化回调
 */
const APPDataController = ({
    AccountDataController, // 设置用户信息
    PEDataController, // 设置 PE 数据
    BusinessInfoController, // 设置 业务数据
    UserAvatarDataController, // 用户头像信息
}) => {
    const infoDataList = [
        "groupVOs", // 组织VOS
        "bizDateTime", // 业务日期
        "userCode", // 用户编码
        "userId", // 用户ID
        "userName", // 用户名
        "projectCode", //项目编码
        "email", // 邮箱
        "nlinkUrl", // pe 调用的请求地址
        "needBind", // 云账号是否需要绑定
        "isRealAuth", // 云账户是否实名认证
        "is_cloud_register", // 是否注册云服务
        'isCaLogin', // 是否ca登录
        'editBizdateEnable', // 是否可修改业务日期
        'deployType', // 云类型 cloud 公有云  private 私有云
        'userType'
    ];
    let infoData = getStore("STOREFORINFODATA", true);
    let {
        groupVOs,
        bizDateTime,
        userCode,
        userId,
        userName,
        projectCode,
        email,
        nlinkUrl, //pe 调用的请求地址
        needBind, //云账号是否需要绑定
        isRealAuth,
        is_cloud_register,
        isCaLogin,
        editBizdateEnable, // 是否可修改业务日期
        deployType,
        userType
    } = ObjToValue(infoData, infoDataList);
    let selectedKey = "";
    let group_name = "";
    if (groupVOs && groupVOs.length > 0) {
        let { pk_group, groupName } = groupVOs.find(item => item.is_selected);
        // 集团主键
        selectedKey = pk_group;
        // 集团名称
        group_name = groupName;
    }
    // 设置用户信息
    if (AccountDataController) {
        AccountDataController({
            newDate: bizDateTime,
            userName: userName,
            currentData: groupVOs,
            businessDate: bizDateTime,
            userId: userId,
            groupId: selectedKey,
            groupName: group_name,
            userCode: userCode,
            email: email,
            projectCode: projectCode,
            nlinkUrl: nlinkUrl,
            // needBind: false,
            // isRealAuth: true,
            needBind: needBind,
            isRealAuth: isRealAuth,
            is_cloud_register: is_cloud_register,
            isCaLogin: isCaLogin,
            editBizdateEnable,
            deployType: deployType,
            userType,
        });
    }
    // 设置 PE 数据
    if (PEDataController) {
        PEDataController({
            userID: userCode, // 用户编码
            projectCode: projectCode, // 项目编码
            nlinkUrl: nlinkUrl, // pe 地址
        });
    }
    // 设置 业务数据
    if (BusinessInfoController) {
        const { bizDateTime, originalBizDateTime, groupVOs, ...otherBusinessInfo } = infoData;
        // 除了业务日期字段需要转一下，组织取出id和name，其余数据保持原状
        BusinessInfoController({
            businessDate: bizDateTime,
            groupId: selectedKey,
            groupName: group_name,
            ...otherBusinessInfo,
        });
    }
    // 用户头像信息
    let UserAvatarData = getStore("STOREFORUSERAVATAR");
    if (UserAvatarData && UserAvatarDataController) {
        UserAvatarDataController(UserAvatarData);
    }
};

/**
 * 返回指定 key 的简单对象
 * @param {*} obj
 * @param {*} key
 *
 */
const ObjToValue = (obj, key) => {
    if (obj == null) { return {}; }
    switch (getType(key)) {
        case "string":
            return obj[key];
        case "array":
            let valObj = {};
            key.forEach(item => {
                valObj[item] = obj[item];
            });
            return valObj;
        default:
            break;
    }
};

/**
 * 刷新整个页面
 */
const RefreshThePage = () => {
    window.location.reload(true);
};

export default APPDataController;
